import axios from 'axios';
import get from 'lodash/get';

export const STRIPE_CUSTOMER_LOADING = 'STRIPE_CUSTOMER_LOADING';
export const STRIPE_CUSTOMER_SUCCESS = 'STRIPE_CUSTOMER_SUCCESS';
export const STRIPE_CUSTOMER_ERROR = 'STRIPE_CUSTOMER_ERROR';

export const CREATE_STRIPE_CUSTOMER_LOADING = 'CREATE_STRIPE_CUSTOMER_LOADING';
export const CREATE_STRIPE_CUSTOMER_SUCCESS = 'CREATE_STRIPE_CUSTOMER_SUCCESS';
export const CREATE_STRIPE_CUSTOMER_ERROR = 'CREATE_STRIPE_CUSTOMER_ERROR';

export function fetchStripeCustomer(stripeCustomerId, callback) {
  return async (dispatch) => {
    dispatch({ type: STRIPE_CUSTOMER_LOADING });
    axios
      .get(
        `${process.env.REACT_APP_STRIPE_HOST_URL}/customers/${stripeCustomerId}`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_KEY}`,
          },
        }
      )
      .then((response) => {
        callback && callback();

        const customer = response.data;
        dispatch({
          type: STRIPE_CUSTOMER_SUCCESS,
          payload: customer,
        });
      })
      .catch((result) => {
        dispatch({
          type: STRIPE_CUSTOMER_ERROR,
          payload: result,
        });
      });
  };
}

export const createStripeCustomerAsync = (email) => async (
  dispatch,
  getState
) => {
  try {
    const state = getState();
    if (!state.user.token) return;
    dispatch({ type: CREATE_STRIPE_CUSTOMER_LOADING });
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/stripe/customers`,
      {
        email,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`,
        },
      }
    );

    dispatch({
      type: CREATE_STRIPE_CUSTOMER_SUCCESS,
      payload: response.data.data,
    });
    return response.data.data;
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.log('catch', error);
    }

    let response = get(error, 'response.data');
    if (!response) {
      response = { message: 'Network Error' };
    }

    dispatch({
      type: CREATE_STRIPE_CUSTOMER_ERROR,
      payload: response,
    });

    throw error;
  }
};

export function createStripeCustomer(email, success, failure) {
  return (dispatch, getState) => {
    const state = getState();

    if (state.user.token) {
      dispatch({ type: CREATE_STRIPE_CUSTOMER_LOADING });

      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/stripe/customers`,
          {
            email,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${state.user.token}`,
            },
          }
        )
        .then((response) => {
          dispatch({
            type: CREATE_STRIPE_CUSTOMER_SUCCESS,
            payload: response.data.data,
          });
          success && success(response.data.data);
        })
        .catch((error) => {
          if (process.env.NODE_ENV !== 'production') {
            console.log('catch', error);
          }

          let response = get(error, 'response.data');
          if (!response) {
            response = { message: 'Network Error' };
          }

          dispatch({
            type: CREATE_STRIPE_CUSTOMER_ERROR,
            payload: response,
          });
          failure && failure(response);
        });
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/stripeCustomerActions.js